module.exports = __webpack_public_path__ + "img/world-class-faculty2.40f91920.jpg";